import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component,useEffect,Fragment } from "react"
import { Link, withRouter } from "react-router-dom"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row,
  } from "elemental-react16"
import queryString from "qs"
import shop from "shop/shop"
import FormCMS from "components/Form/FormCMS"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore"
import { Table } from "semantic-ui-react";
import LoginPage from "../LoginPage"
import { observer } from "mobx-react"
import HeaderCheckout from "pages/checkout/HeaderCheckout";

@observer
export default class NewCustomerPage extends Component {

	constructor() {
		super()
		shop.whoami()
	  }
	  
	  handleLogin = ( e ) => {
		console.log("handleLogin.whoami",shop.session)
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.loginOrfix( {...this.state} )
		  .catch( ( err ) => {
			console.error( err )
			shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
			return false
		  } )
		  .then( session => {
			if ( !session ) return
			shop.loadCategories()
			shop.cart.hydrate()
			shop.cart.update()
			shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
			let redirectTo = referrer || shop.locationAfterLogin
			console.log( "AFTER", redirectTo )
			if ( redirectTo ) {
			  history.push( redirectTo )
			} else {
			  history.push( "/checkout/delivery" )
			}
		  } )
		
		e.preventDefault()
	  }
	  
	  handleUserChange = ( event ) => {
		this.setState( {
		  user: event.target.value
		} )
	  }
	  
	  handlePasswordChange = ( event ) => {
		this.setState( {
		  password: event.target.value
		} )
	  }
	
	state = {
			user    : "",
			password: "",
			guest: shop.session.shopuser.guest || "",
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					uidnr: "",
					glnnr: "",
					customernumber: ""
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: ""
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
				contact: {
					email: "",
					phone: "",
					mobile: "",
					web: "",
					comment: ""
				},
				locale: "",
				deliveraddress: {
					streetnumber: "",
					street: "",
					addition: "",
					pcode: "",
					city: "",
					country: "",
					email: "",
					name1: "",
					name2: "",
					zusatz: "",
					phone: "",
					extras: {
						freecontact: "",
						addition: ""
					}
				}
			}
		}

	handleSendCustReg = async (newCustomer) =>{
		const { currentLanguage } = languageStore
		newCustomer.locale = currentLanguage
		if(this.state.newcust.contact.email == "" || this.state.newcust.contact.phone == ""){
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			return
		}
		this.state.newcust.address.street = this.state.newcust.address.street + ' ' + this.state.newcust.address.streetnumber
		this.state.newcust.contact.mobile = ' '
		if(this.state.newcust.address.deliverstreet != ""){
			this.state.newcust.address.deliverstreet = this.state.newcust.address.deliverstreet + ' ' + this.state.newcust.address.deliverstreetnumber
			this.state.newcust.deliveraddress.street = this.state.newcust.address.deliverstreet
			this.state.newcust.deliveraddress.pcode = this.state.newcust.address.deliverpostcode
			this.state.newcust.deliveraddress.city = this.state.newcust.address.delivercity
			this.state.newcust.deliveraddress.country = this.state.newcust.address.delivercountry
			this.state.newcust.deliveraddress.addition = this.state.newcust.address.deliveraddition
			this.state.newcust.deliveraddress.zusatz = this.state.newcust.address.deliveraddition
			this.state.newcust.deliveraddress.extras.addition = this.state.newcust.address.deliveraddition
			
			shop.cart.setDeliverAddress( this.state.newcust.deliveraddress )
		}

		if(this.state.newcust.address.street != ""){
			shop.session.value.title = this.state.newcust.firm.name
			shop.session.value.street = this.state.newcust.address.street
			shop.session.value.pcode = this.state.newcust.address.postcode
			shop.session.value.city = this.state.newcust.address.city
			shop.session.value.email = this.state.newcust.contact.email
			shop.session.value.custReg = true
			shop.session.value.extras.custReg = true
		}

		try {
		/*await shop.fetch( `/shop/rest/service/request?id=customer_registration`, {
			method: "POST",
			body: JSON.stringify( newCustomer )
		} )*/
		shop.toast( "Kundenregistrierung erfolgreich!" )
		console.log("newcust: ", this.state.newcust)
		shop.session.shopuser.extras.guest = shop.session.shopuser.guest
		const delay = ms => new Promise(
			resolve => setTimeout(resolve, ms)
		  );
		await delay(2000);
		
		//this.props.history.push("/checkout/confirmation/");
		}
		catch (err) {
		console.log( err )
		shop.toast( err )
		}
	}
	
	handleFormClearWeiter = ( ) => {
		console.log("CUSTNUMBER: ",this.state.newcust.firm.customernumber, " LENGTH: ", this.state.newcust.firm.customernumber.length)
		if(this.state.newcust.firm.customernumber != ""){
			if(this.state.newcust.firm.customernumber.length > 8 || this.state.newcust.firm.customernumber.length < 8){
				shop.toast(translate("Keine gültige Kundennummer angegeben!"))
				return
			}
		}
		if(this.state.newcust.firm.name == "" || this.state.newcust.person.salutation == "" || this.state.newcust.person.firstname == "" || this.state.newcust.person.lastname == ""){
			//shop.toast("Alles eingegeben!")
			shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
			return
		} else if(this.state.form2Disabled == false ){
			if(this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			} else if(this.state.form4Disabled == false){
				if(this.state.newcust.contact.mobile == "" || this.state.newcust.contact.phone == ""){
					shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
					return
				}
			}
		}

		if(this.state.form1Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
		}
		else if(this.state.form2Disabled == false && this.state.form3Disabled == true){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form4Disabled: false } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form1Disabled: true } )
			this.setState( { form2Disabled: true } )
			this.setState( { form3Disabled: true } )
			this.setState( { form4Disabled: false } )
		}
		}
	
	handleFormClearDelivery = ( ) => {
		if(this.state.form2Disabled == false ){
			if(this.state.newcust.address.street == "" || this.state.newcust.address.postcode == "" || this.state.newcust.address.city == "" || this.state.newcust.address.country == ""){
				shop.toast(translate("Bitte alle Pflichtfelder ausfüllen!"))
				return
			}
		}
		this.setState( { form1Disabled: true } )
		this.setState( { form2Disabled: true } )
		this.setState( { form3Disabled: false } )
		this.setState( { form4Disabled: true } )
	}

	handleFormClearZurueck  = ( ) => {
		if(this.state.form2Disabled == false){
			this.setState( { form1Disabled: false } )
			this.setState( { form2Disabled: true } )
		}
		else if(this.state.form3Disabled == false){
			this.setState( { form2Disabled: false } )
			this.setState( { form3Disabled: true } )
		}
		else if(this.state.form4Disabled == false){
			if(this.state.newcust.address.deliverstreet == ""){
				this.setState( { form2Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
			else{
				this.setState( { form3Disabled: false } )
				this.setState( { form4Disabled: true } )
			}
		}
		}
	  
	render() {
		const countryOptions = [
			{ key: 'de', value: 'de', flag: 'de', text: 'Deutschland' },
			{ key: 'x', value: 'x', flag: 'x', text: 'Andere' },
		  ]
		  const { currentLanguage } = languageStore
		  let genderOptions =[ ]
		  if(currentLanguage == 'fr'){
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Monsieur' },
				{ key: 'female', value: 'Frau', text: 'Madame' },
			]
		  }
		  else{
			genderOptions = [
				{ key: 'male', value: 'Herr', text: 'Herr' },
				{ key: 'female', value: 'Frau', text: 'Frau' },
			]
		  }

		  const handleChange = (event) => {
			console.log("CHANGE: ", event.target)
			let tempname = event.target.name
			let tempname2 = event.target.className
			let tempvalue = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust[tempname][tempname2] = tempvalue;       
				return { newcust }; 
			  })
		  };  
		  const handleDropDownChange = (event, {value}) => {
			let tempvalue = value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				if(value == "Herr" || value == "Frau"){
					newcust.person.salutation = tempvalue
				} 
				else if(this.state.form2Disabled == false){
					newcust.address.country = tempvalue
				} 
				else if(this.state.form3Disabled == false){
					newcust.address.delivercountry = tempvalue
				}     
				return { newcust }; 
			  })
		  }; 
		
		  const handleDropDownChangeAddress = (event, {value}) => {
			let tempvalue = value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
					newcust.address.country = tempvalue
				   
				return { newcust }; 
			  })
		  }; 

		 const handleCommentChange = ( event ) => {
			console.log("VALUE:",event.target)
			let comment = event.target.value
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust.contact.comment = comment;       
				return { newcust }; 
			  })
		  }
		console.log("WHOAMI ",shop.session)
		console.log("shop.session.value",shop.session.value)

		if(shop.session.shopuser.extras.guest && shop.session.shopuser.extras.guest == true){
			this.setState(prevState => {
				let newcust = { ...prevState.newcust };  
				newcust["firm"]["name"] = shop.session.value.title;       
				return { newcust }; 
			  })
			shop.session.value.title
		}
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history } = this.props
		return (
			<div className="pb4">
				{console.log("confirmationPage shop.register RETURN: ", shop)}
				{<HeaderCheckout onClick={this.handleConfirmationStepActive} activeStep={1}/>}

                {<Fragment>
                <section className="container pt4 pb4">
                    <div className="row-title tc">
                    {/*<h2 className="">{translate( "Als Neukunde/Gast fortfahren" )}</h2>*/}
                    </div><br/>
                    <div>
					<Table>
					<colgroup>
						<col width="48%" />
						<col width="4%" />
						<col width="48%" />
					</colgroup>
					<thead>
						<tr>
							<th><h1>{translate("Als Gast fortfahren")}</h1></th>
							<th>&nbsp;</th>
							<th><h1>{translate("Anmelden")}</h1></th>
						</tr>
					</thead>
					<tbody>
					<tr className="verticalAlignTD">
						<td>
						<div className="mw7 left pb6">
							<br/>
				{translate("Mit dem folgenden Formular können Sie als Gast der orfix International GmbH fortfahren. Füllen Sie dazu bitte alle Felder im Formular aus und klicken Sie dann auf die Schaltfläche »Mit der Bestellung fortfahren«")}
				<br/><br/>

				{/*<strong>{translate("Bitte beachten Sie:")}</strong><br/><br/>*/}

				{/*translate("Wir werden Ihre Anmeldung überprüfen und Ihren Zugang schnellstmöglich freischalten. Nach der Freischaltung erhalten Sie die Zugangsdaten per E-Mail. Nach dem Login können Sie Ihre Bestellung abschließen.")*/}
				

				{<Form>
					<h3>{translate("Angaben zum Unternehmen")}</h3>
						<Form.Field required>
							<label>{translate("Firmenname")}</label>
							<input value={this.state.newcust.firm.name} onChange={handleChange} className="name" name="firm" placeholder={translate("Firmenname")} />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("UID-Nummer")}><input fluid value={this.state.newcust.firm.uidnr} onChange={handleChange} className="uidnr" name="firm" label="Kundennummer:" placeholder={translate("UID-Nummer")}  /></Form.Input>
					</Form.Group>
					<br/>
					<h3>{translate("Angaben zu Ihrer Person")}</h3>
					<Form.Field required>
						<label>{translate("Anrede")}</label>
						<Dropdown
							value={this.state.newcust.person.salutation}
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="salutation" 
							name="person"
							required
							selection
							options={genderOptions}
							placeholder={translate("Anrede")}
						/>
					</Form.Field>
					<Form.Group widths="equal">
						<Form.Input required label={translate("Vorname")}><input fluid value={this.state.newcust.person.firstname} onChange={handleChange} className="firstname" test="firstname" name="person" label="Vorname:" placeholder={translate("Vorname")}  /></Form.Input>
						<Form.Input required label={translate("Nachname")}><input fluid value={this.state.newcust.person.lastname} onChange={handleChange} className="lastname" name="person" label="Nachname:" placeholder={translate("Nachname")}  /></Form.Input>
					</Form.Group>
				</Form>}<br/>
				{<Form>
					<h3>{translate("Angaben zur Rechnungsadresse")}</h3>
						<Form.Group widths="equal">
							<Form.Input width={13} required label={translate("Strasse")}><input value={this.state.newcust.address.street} onChange={handleChange} required fluid className="street" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3} required label={translate("Hausnummer")}><input value={this.state.newcust.address.streetnumber} onChange={handleChange} required fluid className="streetnumber" name="address" label="street:" placeholder={translate("Hausnummer")}  /></Form.Input>
						</Form.Group>
						<Form.Field>
							<label>{translate("Zusatz")}</label>
							<input value={this.state.newcust.address.addition} onChange={handleChange} className="addition" name="address" nameadd="street" placeholder={translate("Zusatz")} />
						</Form.Field>
						<Form.Group widths="equal">
							<Form.Input required label={translate("PLZ")}><input value={this.state.newcust.address.postcode} onChange={handleChange} required fluid className="postcode" name="address" label="PLZ:" placeholder={translate("PLZ")}  /></Form.Input>
							<Form.Input required label={translate("Ort")}><input value={this.state.newcust.address.city} onChange={handleChange} required fluid className="city" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						<Form.Field required>
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.country}
							onChange={handleDropDownChangeAddress}
							clearable
							label="Land:"
							className="country" 
							name="address"
							required
							
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
  				</Form>}<br/>
				  {this.state.form3Disabled == false && <Form>
					<h3>{translate("Angaben zur Lieferadresse")}</h3>
					<Form.Group widths="equal">
							<Form.Input width={13}  label={translate("Strasse")}><input value={this.state.newcust.address.deliverstreet} onChange={handleChange} required fluid className="deliverstreet" name="address" label="street:" placeholder={translate("Strasse")}  /></Form.Input>
							<Form.Input width={3}  label={translate("Hausnummer")}><input value={this.state.newcust.address.deliverstreetnumber} onChange={handleChange} required fluid className="deliverstreetnumber" name="address" label="street:" placeholder={translate("Hausnummer")}  /></Form.Input>
						</Form.Group>
						<Form.Field>
							<label>{translate("Zusatz")}</label>
							<input value={this.state.newcust.address.deliveraddition} onChange={handleChange} className="deliveraddition" name="address" nameadd="street" placeholder={translate("Zusatz")} />
						</Form.Field>
						<Form.Group widths="equal">
							<Form.Input  label={translate("PLZ")}><input value={this.state.newcust.address.deliverpostcode} onChange={handleChange}  fluid className="deliverpostcode" name="address" label="PLZ:" placeholder={translate("PLZ.")}  /></Form.Input>
							<Form.Input  label={translate("Ort")}><input value={this.state.newcust.address.delivercity} onChange={handleChange}  fluid className="delivercity" name="address" label="Ort:" placeholder={translate("Ort")}  /></Form.Input>
						</Form.Group>
						
						<Form.Field >
						<label>{translate("Land")}</label>
						<Dropdown
							value={this.state.newcust.address.delivercountry}
							onChange={handleDropDownChange}
							clearable
							label="Land:"
							className="delivercountry" 
							name="address"
							required
							
							selection
							options={countryOptions}
							placeholder={translate("Land")}
						/>
						</Form.Field>
  				</Form>}<br/>
				  {<Form>
					<h3>{translate("Erreichbarkeit")}</h3>
						<Form.Field required>
							<label>{translate("E-Mail")}</label>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>
						<Form.Field>
							<label>{translate("Webseite")}</label>
							<input value={this.state.newcust.contact.web} onChange={handleChange} className="web" name="contact" nameadd="email" placeholder="shop.orfix.com" />
						</Form.Field>
						<Form.Group widths="equal">
						<Form.Input required label={translate("Telefon")}><input value={this.state.newcust.contact.phone} onChange={handleChange} required fluid className="phone" name="contact" label="Telefon:" placeholder={translate("Telefon")}  /></Form.Input>
						<Form.Input label={translate("Mobil")}><input value={this.state.newcust.contact.mobile} onChange={handleChange} fluid className="mobile" name="contact" label="Mobil:" placeholder={translate("Mobil")}  /></Form.Input>
						</Form.Group>
						<FormField label={translate( "comment" )} htmlFor="supported-controls-input">
							   <FormInput placeholder={translate( "Ihr Kommentar..." )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>
  				</Form>}
				  <div style={{ display: "flex" }} >
				  {/*this.state.form1Disabled == true && <Button onClick={this.handleFormClearZurueck} primary>
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                  </Button>*/}
				  {<Button style={{ marginLeft: "left" }} onClick={this.handleFormClearDelivery} primary>
                    {translate( "Separate Lieferadresse eingeben" )}
                    <i className="icon-angle-right"/>
                  </Button>}
  				{/*this.state.form4Disabled == true && 
		
					<Button style={{ marginLeft: "auto" }} onClick={this.handleFormClearWeiter} primary>
                    {translate( "Weiter" )}
                    <i className="icon-angle-right"/>
                  </Button>*/}
				  {<Button style={{ marginLeft: "auto" }} onClick={() => this.handleSendCustReg(this.state.newcust)} primary>
                    {translate( "Mit der Bestellung fortfahren" )}
                    <i className="icon-angle-right"/>
				</Button>}
				  </div>
				
						</div>
						</td>
						<td>
						</td>
						<td className="verticalAlignTD">
						<div className="mw7 left pb6">
                <br/>
                <div className="pb4">{translate("ANMELDUNG_HINWEIS")}</div>
                
                
                <Form onSubmit={this.handleLogin}>
                  <FormField label="Benutzer"
                             title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
                             htmlFor="basic-form-input-email">
                    <FormInput value={this.state.user}
                               onChange={this.handleUserChange}
                               type="text"
                               placeholder={translate("E-Mail-Adresse / Kunden-Nr.")}
                               name="basic-form-input-id" />
                  </FormField>
                  <FormField label="Passwort"
                             htmlFor="basic-form-input-password">
                    <FormInput value={this.state.password}
                               onChange={this.handlePasswordChange}
                               type="password"
                               placeholder="Passwort"
                               name="basic-form-input-password" />
                  </FormField>
                  {/*<FormField>*/}
                  {/*<Checkbox label="Login speichern" />*/}
                  {/*</FormField>*/}
                  <div className="tc pt3">
                    <Button
                      primary
                      submit
                    >{translate( "Anmelden" )}</Button>
                    <Link className="db mt3"
                          to="/reset_password">{translate( "Passwort vergessen" )}</Link>
                  </div>
                </Form>
				<hr />
				<Message>
              <div className="b f4 pb2">{translate("Bestandskunde? Hier Passwort anfordern.")}</div>
              <div>{translate("BESTANDSKUNDEN_HINWEIS")}</div>
              <div className={"tc pt3"}>
                <Button basic as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
              </div>
            </Message>
              </div>
						</td>
					</tr>
					<tr>
						<td>
							<br/>
				  

					{/*<FormCMS slug={"customer_registration"} onSuccess={() => {
						history.push( "/login" )
						window.swal( translate("Neukundenanmeldung erhalten"), translate("Vielen Dank für Ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail"), "success" )
					}}/>*/}
						</td>
						<td>

						</td>
					</tr>
					
					</tbody>
					</Table>
				
			</div>
                </section>
                </Fragment>}
				
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/pages/checkout/NewCustomerPageGuest.js